import React, { Component } from 'react';
import { Button, ButtonToolbar, Col, Tabs, Tab } from 'react-bootstrap';
import Toggle from 'react-toggle'

import { PropTypes } from 'prop-types';
import { PathStopsActive } from './PathStopsActive';
import { PathStopActiveForm } from './PathStopActiveForm';
import { PathStopsDraft } from './PathStopsDraft';
import { PathStopDraftForm } from './PathStopDraftForm';
import { StopsCommand } from '../commands/StopsCommand';
import { LinesCommand } from '../commands/LinesCommand';
import { PathsCommand } from '../commands/PathsCommand';
import { PathStopsCommand } from '../commands/PathStopsCommand';
import { StopsDraftCommand } from '../commands/StopsDraftCommand';
import { LinesDraftCommand } from '../commands/LinesDraftCommand';
import { PathsDraftCommand } from '../commands/PathsDraftCommand';
import { PathStopsDraftCommand } from '../commands/PathStopsDraftCommand';
import { EditionSelector } from '../../EditionSelector';
import { TitleRow } from '../../TitleRow';
import { LoadingSpinner } from '../../LoadingSpinner';
import { HandleMessage } from '../../HandleMessage';
import { HandleDialog } from '../../HandleDialog';
import { ComparisonHelper } from '../../helpers/ComparisonHelper';
import { RegionsCommand } from '../commands/RegionsCommand';

export class PathStops extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string,
        edition: PropTypes.object,
        addEditionObserver: PropTypes.func,
        removeEditionObserver: PropTypes.func
    }

    constructor(props) {
        super(props);
        this.state = {
            data: {
                active: {
                    regions: [],
                    stops: [],
                    lines: [],
                    paths: [],
                    pathStops: []
                },
                draft: {
                    regions: [],
                    stops: [],
                    lines: [],
                    paths: [],
                    pathStops: []
                }
            },
            form: {
                active: {
                    line: undefined,
                    path: undefined,
                    pathStop: undefined
                },
                draft: {
                    line: undefined,
                    path: undefined,
                    pathStop: undefined
                },
                order: {
                    active: false,
                    draft: false
                }
            },
            render: {
                tab: "active",
                compare: false,
                filter: ""
            },
            actions: {
                active: {
                    isLoadingStops: true,
                    isLoadingLines: true,
                    isLoadingPaths: false,
                    isLoadingRegions: false,
                    isLoadingPathStops: false,
                    isUpdatingPathStop: false,
                    isDeletingPathStop: false,
                },
                draft: {
                    isLoadingStops: true,
                    isLoadingLines: true,
                    isLoadingPaths: false,
                    isLoadingRegions: false,
                    isLoadingPathStops: false,
                    isUpdatingPathStop: false,
                    isDeletingPathStop: false,
                },
                isLoadingEditions: false,
            },
            commands: {
                active: {
                    stops: new StopsCommand(),
                    lines: new LinesCommand(),
                    paths: new PathsCommand(),
                    pathStops: new PathStopsCommand()
                },
                draft: {
                    stops: new StopsDraftCommand(),
                    lines: new LinesDraftCommand(),
                    paths: new PathsDraftCommand(),
                    pathStops: new PathStopsDraftCommand()
                },
                regions: new RegionsCommand()
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            },
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            },
            selectedPathStopIds: {
                active: [],
                draft: []
            },
            selectedPathStopLastClickedIndex: {
                active: null,
                draft: null
            }
        }
    }

    componentDidMount() {
        this.context.selectApp('datamanager', false);
        this.context.addEditionObserver(this);

        const { location, history } = this.props;

        // This means that the page was redirected from lines so we need to set the line in the form
        if (location.state) {
            const { form, render } = this.state;
            const { path, dataType } = location.state;

            form[dataType].path = path;
            render.tab = dataType;

            this.setState({ form, render });

            // Only apply once and then clear
            history.replace({
                ...location,
                state: null
            });
        }

        this._onBeforeUnload = (e) => {
            const { form, render } = this.state;
            if (form && form.order && form.order[render.tab]) {
                const confirmationMessage = "Existem alterações por guardar. Tem a certeza que pretende sair?";
                e.returnValue = confirmationMessage;
                return confirmationMessage;
            }
            return undefined;
        };
        window.addEventListener('beforeunload', this._onBeforeUnload);

        if (this.props && this.props.history && typeof this.props.history.block === 'function') {
            this._preventUnsavedChangesFunction = this.props.history.block((tx) => {
                const { form, render } = this.state;
                if (form && form.order && form.order[render.tab]) {
                    this.requestConfirmDiscardAndExecute('navigate', [tx], "Existem alterações por guardar. Ao mudar de página irá perder essas alterações. Deseja continuar sem guardar?");
                    return false;
                }
                return true;
            });
        }
    }

    componentWillUnmount() {
        this.context.removeEditionObserver(this);

        if (this._onBeforeUnload) {
            window.removeEventListener('beforeunload', this._onBeforeUnload);
            this._onBeforeUnload = null;
        }

        if (this._preventUnsavedChangesFunction) {
            this._preventUnsavedChangesFunction();
            this._preventUnsavedChangesFunction = null;
        }
    }

    // Just to check before performing an action that would discard unsaved changes
    requestConfirmDiscardAndExecute(pendingAction, args, message) {
        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: message || "Existem alterações por guardar. Deseja continuar sem guardar?",
                style: "warning",
                icon: "alert",
                threeButtons: true,
                argument: {
                    pendingAction: pendingAction,
                    args: args
                }
            }
        });
    }

    // ----------------------

    startUpdate() {
        const { actions } = this.state;

        actions.isLoadingEditions = true;

        this.setState({
            actions: actions
        });
    }

    endUpdate() {
        const { actions } = this.state;

        actions.isLoadingEditions = false;

        this.setState({
            actions: actions
        });
    }

    updateNetwork() {
        const { actions } = this.state;

        actions.active.isLoadingLines = true;
        actions.active.isLoadingStops = true;

        this.setState({
            actions: actions
        }, () => {
            const { edition } = this.context;

            this.getLines(edition, "active");
            this.getStops(edition, "active");
        });
    }

    updateDraftNetwork() {
        const { actions } = this.state;

        actions.draft.isLoadingLines = true;
        actions.draft.isLoadingStops = true;

        this.setState({
            actions: actions
        }, () => {
            const { edition } = this.context;

            this.getLines(edition, "draft");
            this.getStops(edition, "draft");
        });
    }

    // ----------------------

    listSuccessCallback(result, dataType, updateData, updateAction, callback) {
        const { data, actions } = this.state;

        actions[dataType][updateAction] = false;
        data[dataType][updateData] = result;

        // Update data
        this.setState({
            data: data,
            actions: actions
        }, () => {
            if ("function" === typeof (callback)) {
                callback();
            }
        });
    }

    listErrorCallback(messageReceived, dataType, updateData, updateAction) {
        const { data, actions, message } = this.state;

        actions[dataType][updateAction] = false;
        data[dataType][updateData] = [];

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            data: data,
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    operationSuccessCallback(result, updateAction, dataType, callback) {
        const { actions, message } = this.state;

        actions[dataType][updateAction] = false;

        if (message.show) {
            result.message = `${message.message}\n${result.message}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: result.message,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });

        if ("function" === typeof callback) {
            callback(result.data);
        }
    }

    operationErrorCallback(messageReceived, updateAction, dataType, callback) {
        const { actions, message } = this.state;

        actions[dataType][updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });

        if ("function" === typeof callback) {
            callback();
        }
    }

    // ----------------------

    getStops(edition, dataType) {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { commands } = this.state;

        commands[dataType].stops.get(
            edition,
            selectedProviderId,
            false,
            (a) => this.listSuccessCallback(a, dataType, "stops", "isLoadingStops"),
            (a) => this.listErrorCallback(a, dataType, "stops", "isLoadingStops")
        );
    }

    getLines(edition, dataType) {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { commands, actions } = this.state;

        actions[dataType].isLoadingLines = true;
        commands[dataType].lines.get(
            edition,
            selectedProviderId,
            (a) => this.listSuccessCallback(a, dataType, "lines", "isLoadingLines", () => this.updateForm(dataType, "line")),
            (a) => this.listErrorCallback(a, dataType, "lines", "isLoadingLines")
        );

        this.setState({
            actions: actions
        });
    }

    updateForm(dataType, type) {
        const { data, form } = this.state;

        // If type is "line" and a path is selected but no line is selected it means that we received the path from redirect
        if (type === "line" && !form[dataType].line && form[dataType].path) {
            let matchingLine;
            if (Array.isArray(data[dataType].lines)) {
                if (dataType === "active") {
                    matchingLine = data[dataType].lines.find(line => Array.isArray(line.paths) && line.paths.some(path =>
                        path.id === form[dataType].path.id
                    ));
                } else if (dataType === "draft") {
                    matchingLine = data[dataType].lines.find(line =>
                        line.id === form[dataType].path.lineId
                    );
                }
            }

            if (!matchingLine) {
                // No matching line found, clear the path selection
                form[dataType].path = undefined;
                this.setState({ form });
            } else {
                // Matching line found, update selections
                this.onChangeLine(matchingLine, dataType, false);
                this.onChangePath(form[dataType].path, dataType);
            }

            // Prevent the second block from running if the first if is triggered
            return;
        }

        // For non-draft dataType, sync form selection with data
        if (dataType !== "draft" && form.active[type] !== undefined) {
            if (type === "line") {
                const selectedLine = data.active.lines.find(x => x.code === form.active.line.code);
                this.onChangeLine(selectedLine, dataType, false);
            } else if (type === "path") {
                const selectedPath = data.active.paths.find(x => x.code === form.active.path.code);
                this.onChangePath(selectedPath, dataType);
            }
        }
    }

    getPaths(edition, line, dataType) {
        let selectedProviderId = "";
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { commands, actions } = this.state;

        actions[dataType].isLoadingPaths = true;
        commands[dataType].paths.getByLine(
            edition,
            line.id,
            selectedProviderId,
            (a) => this.listSuccessCallback(a, dataType, "paths", "isLoadingPaths", () => this.updateForm(dataType, "path")),
            (a) => this.listErrorCallback(a, dataType, "paths", "isLoadingPaths")
        );

        this.setState({
            actions: actions
        });
    }

    getRegions(edition, line, dataType) {
        let selectedProviderId = "";
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { commands, actions } = this.state;

        actions[dataType].isLoadingRegions = true;
        commands.regions.getByLine(
            "active" === dataType ? edition.network : edition.draftNetwork,
            line.id,
            selectedProviderId,
            (a) => this.listSuccessCallback(a, dataType, "regions", "isLoadingRegions"),
            (a) => this.listErrorCallback(a, dataType, "regions", "isLoadingRegions")
        );

        this.setState({
            actions: actions
        });
    }

    getPathStops(edition, path, dataType) {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { commands, actions } = this.state;

        actions[dataType].isLoadingPathStops = true;
        commands[dataType].pathStops.getByPath(
            edition,
            path.id,
            selectedProviderId,
            (a) => this.listSuccessCallback(a, dataType, "pathStops", "isLoadingPathStops", () => this.sortPathStopsList(dataType)),
            (a) => this.listErrorCallback(a, dataType, "pathStops", "isLoadingPathStops")
        );

        this.setState({
            actions: actions
        });
    }

    // ----------------------

    onChangeLine(line, dataType, updatePathForm = true) {
        const { edition } = this.context;
        const { form, render, selectedPathStopIds } = this.state;

        if (form && form.order && form.order[render.tab]) {
            // If changing the same line, just ignore
            const currentLine = form[dataType] && form[dataType].line;
            const sameLine = currentLine && line && currentLine.id === line.id;
            if (!sameLine) {
                this.requestConfirmDiscardAndExecute("changeLine", [line, dataType, updatePathForm], "Existem alterações por guardar. Ao mudar de linha irá perder essas alterações. Deseja continuar sem guardar?");
                return;
            }
        }

        form[dataType].line = line;
        if (updatePathForm) {
            form[dataType].path = undefined;
        }
        selectedPathStopIds[dataType] = [];

        this.setState({
            form: form,
            selectedPathStopIds: selectedPathStopIds
        });

        if (null !== line && undefined !== line) {
            this.getPaths(edition, line, dataType);
            this.getRegions(edition, line, dataType);
        }
        else {
            const { data } = this.state;

            data[dataType].paths = [];

            this.setState({
                data: data
            });
        }
    }

    onChangePath(path, dataType) {
        const { edition } = this.context;
        const { form, render, selectedPathStopIds } = this.state;

        if (form && form.order && form.order[render.tab]) {
            const currentPath = form[dataType] && form[dataType].path;
            const samePath = currentPath && path && currentPath.id === path.id;
            if (!samePath) {
                this.requestConfirmDiscardAndExecute("changePath", [path, dataType], "Existem alterações por guardar. Ao mudar de percurso irá perder essas alterações. Deseja continuar sem guardar?");
                return;
            }
        }

        form[dataType].path = path;
        selectedPathStopIds[dataType] = [];

        this.setState({
            form: form,
            selectedPathStopIds: selectedPathStopIds
        });

        if (null !== path && undefined !== path) {
            this.getPathStops(edition, path, dataType);
        }
        else {
            const { data } = this.state;

            data[dataType].pathStops = [];

            this.setState({
                data: data
            });
        }
    }

    onDragOver(e) {
        e.preventDefault();
    };

    onDragStart(e, idx) {
        e.dataTransfer.setData('index', idx);
    };

    onDrop(e, dataType) {
        const { form, data, selectedPathStopIds } = this.state;

        const rawNewIndex = e.target.dataset.value;
        const newIndex = parseInt(rawNewIndex, 10);

        if (e.shiftKey) {
            const selectedIds = Array.isArray(selectedPathStopIds[dataType]) ? selectedPathStopIds[dataType] : [];

            if (selectedIds.length === 0) {
                return;
            }

            const pathStopsList = data[dataType].pathStops;

            // Get all the original indexes
            const originalIndexById = {};
            pathStopsList.forEach((ps, i) => {
                originalIndexById[ps.id] = i;
            });

            const selectedSet = new Set(selectedIds);

            // Get the selected pathStops ordered by stopOrder
            let selectedPathStops = pathStopsList.filter(ps => selectedSet.has(ps.id));
            selectedPathStops.sort((a, b) => this.sortPathStops(a, b));

            const remainingPathStops = pathStopsList.filter(ps => !selectedSet.has(ps.id));

            // Adjust insertion index to account for removed items that were before newIndex
            let countBefore = selectedPathStops.reduce((acc, ps) => acc + (originalIndexById[ps.id] < newIndex ? 1 : 0), 0);
            if (countBefore > 1) countBefore--;
            let insertIndex = newIndex - countBefore;
            if (insertIndex < 0) insertIndex = 0;
            if (insertIndex > remainingPathStops.length) insertIndex = remainingPathStops.length;

            const pathStopsNewList = [
                ...remainingPathStops.slice(0, insertIndex),
                ...selectedPathStops,
                ...remainingPathStops.slice(insertIndex)
            ];

            pathStopsNewList.forEach((pathStop, i) => {
                pathStop.stopOrder = i + 1;
            });

            data[dataType].pathStops = pathStopsNewList;
            form.order[dataType] = true;

            this.setState({
                data: data,
                form: form
            });
        }
        else {
            const oldIndex = e.dataTransfer.getData('index');

            if (oldIndex !== undefined && newIndex !== undefined) {
                const maxOrder = Math.max(...data[dataType].pathStops.map(pathStop => pathStop.stopOrder), 0) + 1;

                if (newIndex >= maxOrder) {
                    var k = newIndex - maxOrder + 1;
                    while (k--) {
                        data[dataType].pathStops.push(undefined);
                    }
                }

                data[dataType].pathStops.splice(newIndex, 0, data[dataType].pathStops.splice(oldIndex, 1)[0]);
                data[dataType].pathStops.forEach((pathStop, i) => {
                    pathStop.stopOrder = i + 1;
                });
                form.order[dataType] = true;

                this.setState({
                    data: data,
                    form: form
                });
            }
        }
    }

    onChangeValue(e, value, dataType) {
        const { form } = this.state;

        form[dataType].pathStop.obj[value] = e.target.value;

        this.setState({
            form: form,
        });
    }

    onSelectValue(e, value, dataType) {
        const { form } = this.state;

        form[dataType].pathStop.obj[value] = e;

        this.setState({
            form: form,
        });
    }

    onCheckValue(e, value, dataType) {
        const { form } = this.state;

        form[dataType].pathStop.obj[value] = e.target.checked;

        this.setState({
            form: form,
        });
    }

    onSavePathStopSpine(pathStop, isInSpine, callback, dataType) {
        const { edition } = this.context;
        const { commands } = this.state;

        if ("function" === typeof callback) {
            commands[dataType].pathStops.updateSpine(
                edition,
                pathStop.id,
                isInSpine,
                () => this.saveSpineSuccessCallback(pathStop, isInSpine, "isUpdating", dataType, () => callback()),
                (a) => this.operationErrorCallback(a, "isUpdating", dataType, () => callback())
            );
        }
    }

    onSavePathStopComplementaryTerminal(pathStop, isComplementaryTerminal, callback, dataType) {
        const { edition } = this.context;
        const { commands } = this.state;

        if ("function" === typeof callback) {
            commands[dataType].pathStops.updateComplementaryTerminal(
                edition,
                pathStop.id,
                isComplementaryTerminal,
                () => {
                    pathStop.isComplementaryTerminal = isComplementaryTerminal;
                    callback();
                },
                (a) => this.operationErrorCallback(a, "isUpdating", dataType, () => callback())
            );
        }
    }

    onSavePathStopShowDescriptionOutsideSpine(pathStop, showDescriptionOutsideSpine, callback, dataType) {
        const { edition } = this.context;
        const { commands } = this.state;

        if ("function" === typeof callback) {
            commands[dataType].pathStops.updateShowDescriptionOutsideSpine(
                edition,
                pathStop.id,
                showDescriptionOutsideSpine,
                () => {
                    pathStop.showDescriptionOutsideSpine = showDescriptionOutsideSpine;
                    callback();
                },
                (a) => this.operationErrorCallback(a, "isUpdating", dataType, () => callback())
            );
        }
    }

    onSaveAllPathStopsSpine(pathStops, isInSpine, callback, dataType) {
        const { edition } = this.context;
        const { commands } = this.state;

        if ("function" === typeof callback) {
            commands[dataType].pathStops.updateSpineInBulk(
                edition,
                pathStops.map(ps => ps.id),
                isInSpine,
                () => this.saveAllPathStopsSpineSuccessCallback(pathStops, isInSpine, "isUpdating", dataType, () => callback()),
                (a) => this.operationErrorCallback(a, "isUpdating", dataType, () => callback())
            );
        }
    }

    saveAllPathStopsSpineSuccessCallback(pathStops, isInSpine, updateAction, dataType, callback) {
        const { actions } = this.state;
        actions[dataType][updateAction] = false;

        pathStops.forEach(pathStop => {
            pathStop.inSpine = isInSpine;
            if (!isInSpine) {
                pathStop.isComplementaryTerminal = false;
            }
        });

        this.setState({
            actions: actions,
        });

        if ("function" === typeof callback) {
            callback();
        }
    }


    saveSpineSuccessCallback(pathStop, isInSpine, updateAction, dataType, callback) {
        const { actions } = this.state;
        actions[dataType][updateAction] = false;

        pathStop.inSpine = isInSpine;
        if (!isInSpine) {
            pathStop.isComplementaryTerminal = false;
        }

        this.setState({
            actions: actions,
        });

        if ("function" === typeof callback) {
            callback();
        }
    }

    onSavePathStop(dataType) {
        if (!this.isValidInput(dataType)) {
            return null;
        }

        const { edition } = this.context;
        const { form, commands, actions } = this.state;

        actions[dataType].isUpdatingPathStop = true;

        commands[dataType].pathStops.save(
            edition,
            form[dataType].pathStop.obj,
            (a) => this.operationSuccessCallback(a, "isUpdatingPathStop", dataType, () => this.getPathStops(edition, form[dataType].path, dataType)),
            (a) => this.operationErrorCallback(a, "isUpdatingPathStop", dataType)
        );

        this.setState({
            actions: actions
        });

        this.onFormExit(dataType);
    }

    onSaveChangesClick(dataType, afterSaveCallback) {
        const { edition } = this.context;
        const { data, form } = this.state;

        if (0 < data[dataType].pathStops.length && form.order[dataType]) {
            const { commands, actions } = this.state;

            commands[dataType].pathStops.updateInBulk(
                edition,
                data[dataType].pathStops,
                (a) => this.operationSuccessCallback(a, "isUpdatingPathStop", dataType, (resultData) => {
                    this.getPathStops(edition, form[dataType].path, dataType);

                    if ("function" === typeof afterSaveCallback) {
                        afterSaveCallback();
                    }
                }),
                (a) => this.operationErrorCallback(a, "isUpdatingPathStop", dataType, () => this.onSaveChangesError(dataType))
            );

            form.order[dataType] = false;
            actions[dataType].isUpdatingPathStop = true;

            this.setState({
                form: form,
                actions: actions
            });
        }
    }

    onSaveChangesError(dataType) {
        const { form } = this.state;

        form.order[dataType] = true;

        this.setState({
            form: form
        });
    }

    onCreateClick(dataType) {
        const { form } = this.state;

        if (undefined === form[dataType].line || null === form[dataType].line) {
            this.setState({
                message: {
                    show: true,
                    message: "Selecione uma linha",
                    style: "warning",
                    title: "Aviso",
                    icon: "alert"
                }
            });
        }
        else if (undefined === form[dataType].path || null === form[dataType].path) {
            this.setState({
                message: {
                    show: true,
                    message: "Selecione um percurso",
                    style: "warning",
                    title: "Aviso",
                    icon: "alert"
                }
            });
        }
        else {
            const { data } = this.state;

            form[dataType].pathStop = {
                title: "Criar",
                original: undefined,
                obj: {
                    networkEdition: form[dataType].path.networkEdition,
                    path: form[dataType].path,
                    pathId: form[dataType].path.id,
                    prevDistance: "",
                    segmentBreakDuration: "",
                    duration: "",
                    stopOrder: Math.max(...data[dataType].pathStops.map(pathStop => pathStop.stopOrder), 0) + 1,
                    inSpine: false
                },
                durationInputError: null,
                distanceInputError: null,
                stopInputError: null,
            };

            this.setState({
                form: form
            });
        }
    }

    onEditClick(pathStop, dataType) {
        const { form, data, render } = this.state;

        if (render.compare) {
            pathStop = data[dataType].pathStops.find(unmutedPathStop => unmutedPathStop.id === pathStop.id);
        }

        form[dataType].pathStop = {
            title: "Editar",
            original: pathStop,
            obj: Object.assign({
                networkEdition: form[dataType].path.networkEdition,
                path: form[dataType].path,
                pathId: form[dataType].path.id,
                prevDistance: "",
                segmentBreakDuration: "",
                duration: "",
                stopOrder: data[dataType].pathStops.length,
                inSpine: false
            }, pathStop),
            durationInputError: null,
            distanceInputError: null,
            stopInputError: null,
        };

        this.setState({
            form: form
        });
    }

    onRowClickPathStop(pathStop, idx, e, dataType) {
        const { selectedPathStopIds, selectedPathStopLastClickedIndex, data } = this.state;

        if (!Array.isArray(selectedPathStopIds[dataType])) {
            selectedPathStopIds[dataType] = [];
        }

        if (e.shiftKey) {
            const anchor = selectedPathStopLastClickedIndex[dataType] !== null ? selectedPathStopLastClickedIndex[dataType] : 0;
            const from = Math.min(anchor, idx);
            const to = Math.max(anchor, idx);
            const rangeIds = data[dataType].pathStops.slice(from, to + 1).map(ps => ps && ps.id);

            if (selectedPathStopIds[dataType].includes(pathStop.id)) {
                const rangeSet = new Set(rangeIds);
                selectedPathStopIds[dataType] = selectedPathStopIds[dataType].filter(id => !rangeSet.has(id));
            } else {
                const merged = new Set(selectedPathStopIds[dataType]);
                rangeIds.forEach(id => merged.add(id));
                selectedPathStopIds[dataType] = Array.from(merged);
            }
            selectedPathStopLastClickedIndex[dataType] = idx;
        } else {
            const current = selectedPathStopIds[dataType];
            selectedPathStopIds[dataType] = current.includes(pathStop.id)
                ? current.filter(x => x !== pathStop.id)
                : [...current, pathStop.id];
            selectedPathStopLastClickedIndex[dataType] = idx;
        }

        this.setState({
            selectedPathStopIds: selectedPathStopIds,
            selectedPathStopLastClickedIndex: selectedPathStopLastClickedIndex
        });
    }

    onClearSelection(dataType) {
        const { selectedPathStopIds } = this.state;
        selectedPathStopIds[dataType] = [];
        this.setState({ selectedPathStopIds: selectedPathStopIds });
    }

    onDeleteSelectedClick(dataType) {
        const { selectedPathStopIds, form } = this.state;
        const ids = selectedPathStopIds[dataType];

        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: `Tem a certeza que pretende eliminar ${ids.length} paragem(ns) do percurso "${form[dataType].path.code}"?`,
                style: "warning",
                icon: "alert",
                argument: {
                    ids: ids,
                    dataType: dataType
                }
            }
        });
    }

    deleteSequentially(ids, dataType) {
        const { edition } = this.context;
        const { form, commands, selectedPathStopIds } = this.state;
        const remaining = [...ids];

        const deleteNext = () => {
            if (remaining.length === 0) {
                const { actions } = this.state;
                actions[dataType].isDeletingPathStop = false;
                selectedPathStopIds[dataType] = [];
                this.setState({ actions: actions, selectedPathStopIds: selectedPathStopIds });
                this.getPathStops(edition, form[dataType].path, dataType);
                return;
            }
            const id = remaining.shift();
            commands[dataType].pathStops.delete(
                edition,
                id,
                () => deleteNext(),
                (err) => this.operationErrorCallback(err, "isDeletingPathStop", dataType, () => deleteNext())
            );
        };

        deleteNext();
    }

    onDeleteClick(pathStop, dataType) {
        const { form } = this.state;

        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: `Tem a certeza que pretende eliminar a Paragem ${undefined === pathStop.stop ? pathStop.stopName : pathStop.stop.name} do percurso "${form[dataType].path.code}"`,
                style: "warning",
                icon: "alert",
                argument: {
                    id: pathStop.id,
                    dataType: dataType
                }
            }
        });
    }

    onFormExit(dataType) {
        const { form } = this.state;

        form[dataType].pathStop = undefined;

        this.setState({
            form: form
        });
    }

    onSelectTab(key) {
        const { render } = this.state;

        render.tab = key;

        this.setState({
            render: render
        });
    }

    onToggleIsComparing() {
        const { render } = this.state;

        render.compare = !render.compare;

        this.setState({
            render: render
        });
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    onExitDialog(action, argument) {
        const { actions } = this.state;

        if (argument && argument.pendingAction) {
            this.setState({
                dialog: {
                    show: false,
                    title: undefined,
                    message: undefined,
                    style: undefined,
                    icon: undefined,
                    argument: undefined,
                    threeButtons: undefined
                }
            }, () => {
                if (action === 'save') {
                    const { render } = this.state;
                    const dataType = render.tab;
                    
                    this.onSaveChangesClick(dataType, () => this.executePendingAction(argument));
                } else if (action === 'discard') {
                    this.executePendingAction(argument);
                }
            });
            return;
        }

        if (action) {
            const { edition } = this.context;
            const { form, commands } = this.state;

            if (argument.ids) {
                this.deleteSequentially(argument.ids, argument.dataType);
                actions[argument.dataType].isDeletingPathStop = true;
            } else {
                commands[argument.dataType].pathStops.delete(
                    edition,
                    argument.id,
                    (a) => this.operationSuccessCallback(a, "isDeletingPathStop", argument.dataType, () => this.getPathStops(edition, form[argument.dataType].path, argument.dataType)),
                    (a) => this.operationErrorCallback(a, "isDeletingPathStop", argument.dataType)
                );
                actions[argument.dataType].isDeletingPathStop = true;
            }
        }

        this.setState({
            actions: actions,
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined,
                threeButtons: undefined
            }
        });
    }

    executePendingAction(argument) {
        if (!argument || !argument.pendingAction) {
            return;
        }

        const { pendingAction, args } = argument;
        const dataType = this.state.render.tab;
        const { form } = this.state;
        if (form && form.order) {
            form.order[dataType] = false;
            this.setState({ form: form });
        }

        switch (pendingAction) {
            case "changeLine":
                this.onChangeLine(args[0], args[1]);
                break;
            case "changePath":
                this.onChangePath(args[0], args[1]);
                break;
            case "navigate":
                const target = args[0];
                this.props.history.push(target);
                break;
            default:
                break;
        }
    }

    // ----------------------

    isValidInput(dataType) {
        const { form } = this.state;
        let errors = 0;

        if (
            (
                (isNaN(form[dataType].pathStop.obj.segmentBreakDuration) && form[dataType].pathStop.obj.segmentBreakDuration < 0) || "" === form[dataType].pathStop.obj.segmentBreakDuration
            ) &&
            (
                (isNaN(form[dataType].pathStop.obj.duration) && form[dataType].pathStop.obj.duration < 0) || "" === form[dataType].pathStop.obj.duration
            )
        ) {
            form[dataType].pathStop.durationInputError = "error";
            errors++;
        }

        if ((isNaN(form[dataType].pathStop.obj.prevDistance) && form[dataType].pathStop.obj.prevDistance < 0) || "" === form[dataType].pathStop.obj.prevDistance) {
            form[dataType].pathStop.distanceInputError = "error";
            errors++;
        }

        if (
            (undefined === form[dataType].pathStop.obj.stop || null === form[dataType].pathStop.obj.stop || "" === form[dataType].pathStop.obj.stop || 0 === form[dataType].pathStop.obj.stop.id) &&
            (undefined === form[dataType].pathStop.obj.stop && (undefined === form[dataType].pathStop.obj.stopId || null === form[dataType].pathStop.obj.stopId || "" === form[dataType].pathStop.obj.stopId || 0 === form[dataType].pathStop.obj.stopId))
        ) {
            form[dataType].pathStop.stopInputError = "error";
            errors++;
        }

        this.setState({
            form: form
        });

        return 0 === errors;
    }

    sortPathStopsList(dataType) {
        const { data } = this.state;

        data[dataType].pathStops.sort((a, b) => this.sortPathStops(a, b));

        this.setState({
            data: data
        });
    }

    sortPathStops(a, b) {
        let aStopOrder = a.stopOrder;
        let bStopOrder = b.stopOrder;

        if ("object" === typeof aStopOrder) {
            aStopOrder = undefined !== aStopOrder.left ? aStopOrder.left : aStopOrder.right;
        }

        if ("object" === typeof bStopOrder) {
            bStopOrder = undefined !== bStopOrder.left ? bStopOrder.left : bStopOrder.right;
        }

        return aStopOrder !== bStopOrder ? aStopOrder < bStopOrder ? -1 : 1 : 0;
    }

    parseRegionsValue(regions) {
        if (!Array.isArray(regions)) {
            return undefined;
        }

        return regions.map(region => region.name).sort().join(",");
    }

    // ----------------------

    renderActiveForm() {
        const { form } = this.state;

        if (undefined === form.active.pathStop) {
            return null;
        }

        const { data } = this.state;

        const activePathStops = data.active.pathStops;
        const minActiveOrder = activePathStops.length > 0 ? Math.min(...activePathStops.map(ps => ps.stopOrder)) : null;
        const maxActiveOrder = activePathStops.length > 0 ? Math.max(...activePathStops.map(ps => ps.stopOrder)) : null;
        const editedOrder = form.active.pathStop.obj.stopOrder;
        const isFirstOrLastActive = editedOrder === minActiveOrder || editedOrder === maxActiveOrder;

        return (
            <PathStopActiveForm show={true}
                form={form.active.pathStop}
                line={form.active.line}
                path={form.active.path}
                stops={data.active.stops}
                regions={data.active.regions}
                isFirstOrLast={isFirstOrLastActive}
                onChangeValue={(a, b) => this.onChangeValue(a, b, "active")}
                onSelectValue={(a, b) => this.onSelectValue(a, b, "active")}
                onCheckValue={(a, b) => this.onCheckValue(a, b, "active")}
                onSave={() => this.onSavePathStop("active")}
                onHide={() => this.onFormExit("active")} />
        );
    }

    renderDraftForm() {
        const { form } = this.state;

        if (undefined === form.draft.pathStop) {
            return null;
        }

        const { data } = this.state;

        const draftPathStops = data.draft.pathStops;
        const minDraftOrder = draftPathStops.length > 0 ? Math.min(...draftPathStops.map(ps => ps.stopOrder)) : null;
        const maxDraftOrder = draftPathStops.length > 0 ? Math.max(...draftPathStops.map(ps => ps.stopOrder)) : null;
        const editedDraftOrder = form.draft.pathStop.obj.stopOrder;
        const isFirstOrLastDraft = editedDraftOrder === minDraftOrder || editedDraftOrder === maxDraftOrder;

        return (
            <PathStopDraftForm show={true}
                form={form.draft.pathStop}
                line={form.draft.line}
                path={form.draft.path}
                stops={data.draft.stops.filter(stop => stop.networkEdition === form.draft.line.networkEdition)}
                regions={data.draft.regions}
                isFirstOrLast={isFirstOrLastDraft}
                onChangeValue={(a, b) => this.onChangeValue(a, b, "draft")}
                onSelectValue={(a, b) => this.onSelectValue(a, b, "draft")}
                onCheckValue={(a, b) => this.onCheckValue(a, b, "draft")}
                onSave={() => this.onSavePathStop("draft")}
                onHide={() => this.onFormExit("draft")} />
        );
    }

    renderPathsActive() {
        const { data, form, render, actions, selectedPathStopIds } = this.state;

        if (actions.active.isLoadingLines) {
            return (<LoadingSpinner />)
        }

        let pathStopsToRender = data.active.pathStops;
        if (render.compare) {
            const draftPathStops = data.draft.pathStops;

            pathStopsToRender = ComparisonHelper.compare(
                pathStopsToRender,
                (undefined === form.active.line || undefined === form.active.path) ? [] : draftPathStops.filter(dps => dps.lineCode === form.active.line.code && dps.pathCode === form.active.path.code),
                {
                    match: [{ left: "stopOrder", right: "stopOrder" }],
                    fields: [
                        { left: "segmentBreakDuration", right: "duration" },
                        { left: "stop.name", right: "stopName" },
                        { left: "stop.code", right: "stopCode" },
                        { left: "stop.shortName", right: "stopShortName" },
                        { left: "regions", right: "regions", leftParser: (a) => this.parseRegionsValue(a), rightParser: (a) => this.parseRegionsValue(a) }]
                });
        }

        return (
            <PathStopsActive lines={data.active.lines}
                paths={data.active.paths}
                pathStops={pathStopsToRender}
                lineSelected={form.active.line}
                pathSelected={form.active.path}
                isLoadingPaths={actions.active.isLoadingPaths}
                isLoadingPathStops={actions.active.isLoadingPathStops}
                isComparing={render.compare}
                onDrop={(a) => this.onDrop(a, "active")}
                onDragStart={(a, b) => this.onDragStart(a, b)}
                onDragOver={(a) => this.onDragOver(a)}
                onChangeLine={(a) => this.onChangeLine(a, "active")}
                onChangePath={(a) => this.onChangePath(a, "active")}
                onEditClick={(a) => this.onEditClick(a, "active")}
                onDeleteClick={(a) => this.onDeleteClick(a, "active")}
                onSavePathStopSpine={(a, b, c) => this.onSavePathStopSpine(a, b, c, "active")}
                onSaveAllPathStopsSpine={(a, b, c) => this.onSaveAllPathStopsSpine(a, b, c, "active")}
                onSavePathStopComplementaryTerminal={(a, b, c) => this.onSavePathStopComplementaryTerminal(a, b, c, "active")}
                onSavePathStopShowDescriptionOutsideSpine={(a, b, c) => this.onSavePathStopShowDescriptionOutsideSpine(a, b, c, "active")}
                selectedIds={selectedPathStopIds.active}
                onRowClick = {(ps, idx, e) => this.onRowClickPathStop(ps, idx, e, "active")} />
        );
    }

    renderPathsDraft() {
        const { data, form, actions, selectedPathStopIds } = this.state;

        if (actions.draft.isLoadingLines) {
            return (<LoadingSpinner />)
        }

        return (
            <PathStopsDraft lines={data.draft.lines}
                paths={data.draft.paths}
                pathStops={data.draft.pathStops}
                lineSelected={form.draft.line}
                pathSelected={form.draft.path}
                isLoadingPaths={actions.draft.isLoadingPaths}
                isLoadingPathStops={actions.draft.isLoadingPathStops}
                onDrop={(a) => this.onDrop(a, "draft")}
                onDragStart={(a, b) => this.onDragStart(a, b)}
                onDragOver={(a) => this.onDragOver(a)}
                onChangeLine={(a) => this.onChangeLine(a, "draft")}
                onChangePath={(a) => this.onChangePath(a, "draft")}
                onEditClick={(a) => this.onEditClick(a, "draft")}
                onDeleteClick={(a) => this.onDeleteClick(a, "draft")}
                onSavePathStopSpine={(a, b, c) => this.onSavePathStopSpine(a, b, c, "draft")}
                onSaveAllPathStopsSpine={(a, b, c) => this.onSaveAllPathStopsSpine(a, b, c, "draft")}
                onSavePathStopComplementaryTerminal={(a, b, c) => this.onSavePathStopComplementaryTerminal(a, b, c, "draft")}
                selectedIds={selectedPathStopIds.draft}
                onRowClick={(ps, idx, e) => this.onRowClickPathStop(ps, idx, e, "draft")} />
        );
    }

    renderTabOptions(render) {
        if ("active" === render.tab) {
            return (
                <div className="tab-options">
                    <label>
                        <Toggle className="comparison-toggle"
                            checked={render.compare}
                            icons={false}
                            onChange={() => this.onToggleIsComparing()} />
                        <span>COMPARAR</span>
                    </label>
                </div>
            );
        }

        return null;
    }

    renderTabs() {
        const { render } = this.state;

        return (
            <div className="tab-with-options">
                <Tabs id="datamanager_tabs" activeKey={render.tab} onSelect={(a) => this.onSelectTab(a)}>
                    <Tab eventKey="active" key="active" title="Rede Ativa">
                        {this.renderPathsActive()}
                    </Tab>
                    <Tab eventKey="draft" key="draft" title="Rascunho">
                        {this.renderPathsDraft()}
                    </Tab>
                </Tabs>
                {this.renderTabOptions(render)}
            </div>
        );
    }

    renderButtons() {
        const { render, form, selectedPathStopIds, actions } = this.state;
        const selectedCount = selectedPathStopIds[render.tab].length;

        return (
            <ButtonToolbar className="pull-right title-row-col-btns">
                {selectedCount > 0 && (
                    <Button bsStyle="danger" disabled={actions[render.tab].isDeletingPathStop} onClick={() => this.onDeleteSelectedClick(render.tab)}>
                        ELIMINAR SELECIONADOS ({selectedCount})
                    </Button>
                )}
                {selectedCount > 0 && (
                    <Button onClick={() => this.onClearSelection(render.tab)}>LIMPAR SELEÇÃO</Button>
                )}
                <Button disabled={!form.order[render.tab]} onClick={() => this.onSaveChangesClick(render.tab)}>GUARDAR ALTERAÇÕES</Button>
                <Button onClick={() => this.onCreateClick(render.tab)}>ADICIONAR</Button>
            </ButtonToolbar>
        );
    }

    renderOperationFeedback(text, isExecuting) {
        return (
            <HandleMessage
                title={text}
                message={<LoadingSpinner />}
                style={`primary`}
                icon="transfer"
                show={isExecuting}
                small
                noButtons />
        );
    }

    render() {
        const { actions, message, dialog } = this.state;

        return (
            <div>
                <EditionSelector />

                <div>
                    <TitleRow title="Paragens por Percurso" showSeparator={true}>
                        <Col className="padding-0" xs={12} sm={12} md={12}>
                            {this.renderButtons()}
                        </Col>
                    </TitleRow>

                    <div className="margin-top-15">
                        {this.renderTabs()}
                    </div>
                </div>

                {this.renderActiveForm()}
                {this.renderDraftForm()}

                {
                    this.renderOperationFeedback(
                        "A Executar...",
                        actions.active.isUpdatingPathStop || actions.active.isDeletingPathStop || actions.draft.isUpdatingPathStop || actions.draft.isDeletingPathStop
                    )
                }
                {this.renderOperationFeedback("A Carregar Edição...", actions.isLoadingEditions)}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />

                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    threeButtons={dialog.threeButtons}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
            </div>
        );
    }
}
